/* eslint-disable no-undef */
// media-lightbox.js

window.scriptsLoading = window.scriptsLoading || {}

class MediaLightbox extends HTMLElement {
  constructor () {
    super()
    this.isLightboxLoaded = false
    this.glightboxInstance = null

    // Bind methods
    this.onResize = this.onResize.bind(this)
    this.openLightbox = this.openLightbox.bind(this)
  }

  connectedCallback () {
    if (window.innerWidth >= 768) {
      this.loadLightbox()
    }
    this.attachEventListeners()
    window.addEventListener('resize', this.onResize)
  }

  disconnectedCallback () {
    window.removeEventListener('resize', this.onResize)
  }

  attachEventListeners () {
    this.images = this.querySelectorAll('.media-grid-carousel__slide img')
    const triggers = this.querySelectorAll('.media-lightbox-trigger')

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (evt) => {
        evt.preventDefault()
        const imgEl = trigger.querySelector('img')
        if (imgEl) {
          // Find index of the clicked img among all images
          const index = Array.from(this.images).indexOf(imgEl)
          this.openLightbox(index)
        } else {
          // The "View All Photos" button
          this.openLightbox(0)
        }
      })
    })
  }

  openLightbox (index = 0) {
    this.loadLightbox(() => {
      if (!this.glightboxInstance) return
      // Build the fresh list of slides
      const slideElements = this.buildSlideElements()
      this.glightboxInstance.setElements(slideElements)
      this.glightboxInstance.openAt(index)
    })
  }

  /**
   * UPDATED buildSlideElements()
   * ---------------------------------------
   * Checks for data-image-full first; if not found, use the <img> src.
   */
  buildSlideElements () {
    const slides = []
    // Each .media-grid-carousel__item is a "slide"
    this.querySelectorAll('.media-grid-carousel__item').forEach((itemEl) => {
      const highResUrl = itemEl.getAttribute('data-image-full')
      const imgEl = itemEl.querySelector('img')
      const fallbackUrl = imgEl ? imgEl.src : ''

      // If data-image-full is set, use that; otherwise use the fallback
      slides.push({
        href: highResUrl || fallbackUrl,
        type: 'image',
      })
    })
    return slides
  }

  loadLightbox (callback) {
    if (this.isLightboxLoaded) {
      callback && callback()
      return
    }

    if (window.innerWidth < 768) {
      callback && callback()
      return
    }

    const cssLink = document.createElement('link')
    cssLink.rel = 'stylesheet'
    cssLink.href = 'https://cdn.jsdelivr.net/npm/glightbox/dist/css/glightbox.min.css'
    document.head.appendChild(cssLink)

    window.Tentbox.loadScript('https://cdn.jsdelivr.net/npm/glightbox/dist/js/glightbox.min.js', (err) => {
      if (err) {
        console.error('Failed to load GLightbox:', err)
        callback && callback(err)
        return
      }
      this.isLightboxLoaded = true
      this.glightboxInstance = GLightbox({
        touchNavigation: true,
        loop: true,
        openEffect: 'fade',
        closeEffect: 'none',
        slideEffect: 'none',
        backgroundColor: 'rgb(0, 0, 0)',
        cssEfects: {
          fade: { in: 'fadeIn', out: 'fadeOut' },
        },
        zoomable: false,
        draggable: true,
        width: '90vw',
        height: '90vh',
        preload: true,
        touchFollowAxis: true,
        plyr: {
          config: { fullscreen: { enabled: false } },
        },
      })

      this.glightboxInstance.on('slide_before_load', () => {
        const slides = document.querySelectorAll('.gslide img')
        slides.forEach(slide => {
          slide.style.pointerEvents = 'none'
          slide.style.userSelect = 'none'
        })
      })

      callback && callback()
    })
  }

  onResize () {
    this.loadLightbox()
  }
}

if (!customElements.get('media-lightbox')) {
  customElements.define('media-lightbox', MediaLightbox)
}
